// src/components/ui/Button.js
import React from "react";

export function Button({
  children,
  className = "",
  type = "button",
  onClick,
  disabled = false,
  variant = "primary",
  size = "md",
  ...props
}) {
  const variantClasses = {
    primary: "ui-btn-primary",
    secondary: "ui-btn-secondary",
    danger: "ui-btn-danger",
  };

  const sizeClasses = {
    sm: "px-3 py-2 text-sm",
    md: "px-4 py-2.5 text-sm",
    lg: "px-5 py-3 text-base",
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${variantClasses[variant] || variantClasses.primary} ${sizeClasses[size] || sizeClasses.md} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
